export default __webpack_public_path__ + "static/media/1464.6c690c3b.png";